import type { SchemaBuilderConditionRowProps } from "./schema-builder-condition-row.type";

import { useTranslation } from "react-i18next";

import { SchemaBuilderFormListRow } from "../../schema-builder-form-list";
import { SchemaBuilderConditionFieldModel } from "../schema-builder-condition-field-model";
import { SchemaBuilderConditionFieldOperator } from "../schema-builder-condition-field-operator";
import { SchemaBuilderConditionFieldValue } from "../schema-builder-condition-field-value";

import { useSchemaBuilderConditionRow } from "./schema-builder-condition-row.hook";

export const SchemaBuilderConditionRow = ({
  field,
  index,
  fieldPath,
  initialValues,
  onDeleteClick,
}: SchemaBuilderConditionRowProps) => {
  const { t } = useTranslation();

  const { isEmptyOperator, onOperatorChange } = useSchemaBuilderConditionRow({
    fieldPath,
    initialValues,
  });

  return (
    <SchemaBuilderFormListRow
      index={index}
      title={t("schema:conditions.rowTitle")}
      deleteText={t("schema:conditions.delete")}
      onDeleteClick={onDeleteClick}
      content={
        <div className="schema-builder-condition-row">
          <SchemaBuilderConditionFieldModel field={field} />
          <SchemaBuilderConditionFieldOperator
            field={field}
            onChange={onOperatorChange}
          />
          <SchemaBuilderConditionFieldValue
            field={field}
            isRequired={!isEmptyOperator}
          />
        </div>
      }
    />
  );
};
